import { useEffect, useState } from "react";
import { Download, Share, SquarePlus, X } from "lucide-react";

const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

export default function InstallBanner() {
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("fc_install_dismissed") === "1");
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => setInstalled(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  if (installed || dismissed) return null;
  const ios = isIOS();
  if (!ios && !deferred) return null;

  const dismiss = () => { localStorage.setItem("fc_install_dismissed", "1"); setDismissed(true); };
  const install = async () => {
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") setInstalled(true);
    setDeferred(null);
  };

  return (
    <div className="bg-gold-500/10 border-b border-gold-500/30 px-4 py-3" data-testid="field-install-banner">
      <div className="flex items-start gap-3">
        <Download className="h-4 w-4 text-gold-400 mt-0.5 shrink-0" />
        <div className="flex-1 text-xs leading-relaxed">
          {ios ? (
            <span className="text-white/80">
              Put FieldClaim on your home screen: tap <Share className="h-3.5 w-3.5 inline text-gold-300 mx-0.5" /> <b>Share</b>, then
              <SquarePlus className="h-3.5 w-3.5 inline text-gold-300 mx-0.5" /> <b>Add to Home Screen</b>.
            </span>
          ) : (
            <span className="text-white/80">Install FieldClaim on this phone — works offline, opens like a normal app.</span>
          )}
          {!ios && (
            <button onClick={install} data-testid="field-install-btn"
              className="block mt-2 bg-gold-500 text-navy-950 font-semibold px-4 py-2 rounded-sm text-xs">
              Install FieldClaim
            </button>
          )}
        </div>
        <button onClick={dismiss} data-testid="field-install-dismiss" className="text-white/40 p-1"><X className="h-4 w-4" /></button>
      </div>
    </div>
  );
}
